<template>
  <div class="anon-checkbox">
      <input ref="checkbox" type="checkbox" v-model="checked">
      <label @click="toggle" tabindex="0" @keypress.enter.space="toggle" v-bind:class="{ 'disabled' : disableToggle }">&nbsp;</label>
  </div>
</template>

<script>

export default {
  // reverse is used when the toggle switch should display the opposite of value
  props: ['value', 'reverse', 'disableToggle'],
  data: function () {
    return {
      checked: false
    }
  },
  computed: {
    id: function () {
      return `switch_${this._uid}`
    }
  },
  watch: {
    value: function (value) {
      this.checked = this.reverse ? !value : value
    }
  },
  beforeMount: function () {
    this.checked = this.reverse ? !this.value : this.value
  },
  methods: {
    toggle: function () {
      this.checked = !this.checked
      this.reverse ? this.$emit('input', !this.checked) : this.$emit('input', this.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $off-colour: $grey-lighter;
  $on-colour: $primary-gradient;

  .anon-checkbox{
    height: 1.5rem;
    display: inline-block;
  }

  input {
    margin-left: -999px;
    display: none;
  }

  label {
    position: relative;
    text-indent: 2rem;
    cursor: pointer;
    user-select: none;
    height: 100%;
    display: block;

    &:before,
    &:after {
      position: absolute;
      display: block;
      top: 0;
      bottom: 0;
      left: 0;
      content: ' ';
      width: 2.5rem;
      background: $grey-lighter;
      border-radius: 1rem;
      -webkit-transition: all 100ms ease-in;
      transition: all 100ms ease-in;
    }

    &:after {
      width: 50%;
      margin: 0.2rem;
      background-color: #fff;
      border-radius: 100%;
    }
  }

  input:empty ~ svg {
    fill: $off-colour;
  }

  input:checked {
    ~svg {fill: $on-colour;}
    ~label:before { background: $on-colour; }
    ~label:after { margin-left: 1.2rem; }
  }
  .disabled {
    pointer-events: none;
    background-color: #ffffff;
    opacity: 0.40;
    cursor: not-allowed;
  }

</style>
